import * as path from 'node:path';
import type { SimpleGit } from 'simple-git';
import { readBranchRemoteConfig, trackingRefCandidates } from './branch-remote-config.js';
import { firstResolvedSha } from './first-resolved-ref.js';
import { resolveDefaultRemoteBranchSha } from './resolve-default-remote-branch-ref.js';

const BASE_SHA_CACHE_TTL_MS = 30_000;
const baseShaCache = new Map<string, { baseSha: string | null; expiresAt: number }>();

async function resolveBaseShaForUnpushedCommitsUncached(g: SimpleGit): Promise<string | null> {
  const config = await readBranchRemoteConfig(g);
  const trackingSha = await firstResolvedSha(g, trackingRefCandidates(config));
  if (trackingSha) return trackingSha;
  return resolveDefaultRemoteBranchSha(g, config.remote);
}

/**
 * Commit SHA to compare HEAD against for "unpushed" commits:
 * upstream tip when a remote-tracking ref exists; otherwise the remote's default branch tip.
 */
export async function resolveBaseShaForUnpushedCommits(
  g: SimpleGit,
  repoDir?: string,
): Promise<string | null> {
  if (repoDir) {
    const key = path.resolve(repoDir);
    const now = Date.now();
    const cached = baseShaCache.get(key);
    if (cached && cached.expiresAt > now) return cached.baseSha;
    const baseSha = await resolveBaseShaForUnpushedCommitsUncached(g);
    baseShaCache.set(key, { baseSha, expiresAt: now + BASE_SHA_CACHE_TTL_MS });
    return baseSha;
  }
  return resolveBaseShaForUnpushedCommitsUncached(g);
}
